import { getDescriptionError } from '../../validations/description';
import { updateListingScore } from '../../product/score';
import { clearErrors } from '../../errors';
import { escapeRegex } from '../../string';

import { FIND, OPERATIONS, REPLACE } from '../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { FORM } from '../../../constants/forms';

export default function description({ actions, operation, product, titleFormatPreference }) {
  const channel = product.get('channel');

  function setValueToProduct(value) {
    let result = product.setIn([FORM.DESCRIPTION, VALUE], value);

    if (operation.hasIn(['ai', 'original'])) {
      result = result.setIn([FORM.DESCRIPTION, 'ai'], operation.get('ai'));
    }

    if (result.hasIn(['score', ATTRIBUTE.DESCRIPTION])) {
      result = updateListingScore(result, { titleFormatPreference });
    }

    return result;
  }

  function validateAndApply(value) {
    return {
      actions,
      product: getDescriptionError({ channel, value })
        ? product
        : clearErrors({ errors: [ATTRIBUTE.DESCRIPTION], product: setValueToProduct(value) }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].DESCRIPTION.ADD_AFTER: {
      const value = `${product.getIn([FORM.DESCRIPTION, VALUE])}${operation.get(VALUE)}`;
      return validateAndApply(value);
    }

    case OPERATIONS[channel].DESCRIPTION.ADD_BEFORE: {
      const value = `${operation.get(VALUE)}${product.getIn([FORM.DESCRIPTION, VALUE])}`;
      return validateAndApply(value);
    }

    case OPERATIONS[channel].DESCRIPTION.DELETE: {
      const pattern = new RegExp(escapeRegex(operation.get(VALUE)), 'ig');
      const value = product.getIn([FORM.DESCRIPTION, VALUE]).replace(pattern, '');
      return validateAndApply(value);
    }

    case OPERATIONS[channel].DESCRIPTION.FIND_AND_REPLACE: {
      const pattern = new RegExp(escapeRegex(operation.getIn([VALUE, FIND])), 'ig');
      const value = product
        .getIn([FORM.DESCRIPTION, VALUE])
        .replace(pattern, operation.getIn([VALUE, REPLACE]));

      return validateAndApply(value);
    }

    case OPERATIONS[channel].DESCRIPTION.SET: {
      const value = operation.get(VALUE);
      return validateAndApply(value);
    }

    default: {
      return { actions, product };
    }
  }
}
